import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex border pr-3 pl-3 py-2 mb-2 shadow-md text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900",
  style: {"user-select":"contain","max-width":"70vw","border-radius":"1rem"}
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "mt-1 ml-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-xl" }, " close ", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "focus:outline-none select-none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsErrorShow(false)))
        }, _hoisted_5)
      ])
    ])
  ]))
}